import { render, staticRenderFns } from "./thyaktarimxml.vue?vue&type=template&id=6c57c388&"
import script from "./thyaktarimxml.vue?vue&type=script&lang=js&"
export * from "./thyaktarimxml.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports